export default __webpack_public_path__ + "static/media/city.9c40c61b.png";